import type { StudentStatus } from '@/types/student';

/**
 * How the register describes a student's standing.
 *
 * The words an institute would print on a return or a transfer certificate,
 * rather than staffroom shorthand — this list is read by registrars and
 * auditors as often as by teachers, and "Passed out" is not a term that belongs
 * on a record.
 *
 * Mirrors the `StudentStatus` Prisma enum. Shared because the fee summary
 * narrows by standing too, and must name each one the way the register does.
 */
export const STUDENT_STATUS_LABEL = {
  ACTIVE: 'Enrolled',
  INACTIVE: 'Inactive',
  TRANSFERRED: 'Transferred',
  ALUMNI: 'Alumni',
  SUSPENDED: 'Suspended',
} as const satisfies Record<StudentStatus, string>;
